import {BASE_ADMIN_API, fetchAPI} from '@/services/api';

export interface OperationLogRuleVO {
    id?: number;
    pageName?: string;
    featureName?: string;
    urlPattern?: string;
    httpMethod?: string;
    serviceName?: string;
    enabled?: number;
    sortOrder?: number;
    remark?: string;
    createTime?: string;
    updateTime?: string;
}

export interface OperationLogRuleQueryBO {
    pageNum?: number;
    pageSize?: number;
    pageName?: string;
    featureName?: string;
    urlPattern?: string;
    httpMethod?: string;
    serviceName?: string;
    enabled?: number;
}

export interface OperationLogRulePage {
    records: OperationLogRuleVO[];
    total: number;
    size: number;
    current: number;
    pages: number;
}

export interface OperationLogRuleSaveBO {
    id?: number;
    pageName: string;
    featureName: string;
    urlPattern: string;
    httpMethod?: string;
    serviceName?: string;
    enabled?: number;
    sortOrder?: number;
    remark?: string;
}

const base = `${BASE_ADMIN_API}/operation-log-rule`;

export async function queryPage(query: OperationLogRuleQueryBO) {
    return fetchAPI<OperationLogRulePage>(`${base}/queryPage`, {
        method: 'POST',
        body: JSON.stringify(query),
    });
}

export async function getById(id: number) {
    return fetchAPI<OperationLogRuleVO>(`${base}/get?id=${id}`, {method: 'GET'});
}

export async function save(bo: OperationLogRuleSaveBO) {
    return fetchAPI<number>(`${base}/save`, {
        method: 'POST',
        body: JSON.stringify(bo),
    });
}

export async function update(bo: OperationLogRuleSaveBO) {
    return fetchAPI<boolean>(`${base}/update`, {
        method: 'PUT',
        body: JSON.stringify(bo),
    });
}

export async function updateEnabled(id: number, enabled: number) {
    return fetchAPI<boolean>(`${base}/updateEnabled`, {
        method: 'PUT',
        body: JSON.stringify({id, enabled}),
    });
}

export async function remove(id: number) {
    return fetchAPI<boolean>(`${base}/delete?id=${id}`, {method: 'DELETE'});
}

export async function resyncSeed() {
    return fetchAPI<number>(`${base}/resync-seed`, {method: 'POST'});
}

export const OperationLogRuleService = {
    queryPage,
    getById,
    save,
    update,
    updateEnabled,
    remove,
    resyncSeed,
};
